import React, { useEffect } from "react"; // Importa useEffect
import Hero from "../components/Hero";
import styles from "../styles/precios.module.css";
import { useLocation } from "react-router-dom"; // Importa useLocation

export default function Precios() {
    const location = useLocation(); // Obtiene el objeto de ubicación

    // useEffect para enviar un evento a Google Analytics cuando la página de precios se carga
    useEffect(() => {
        // Asegúrate de que gtag esté disponible globalmente antes de usarlo
        if (typeof window.gtag === 'function') {
            window.gtag('event', 'view_prices_page', {
                'event_category': 'Engagement',
                'event_label': 'Página de Precios Vista',
                'page_path': location.pathname, // Puedes incluir la ruta actual
                'page_title': document.title // El título de la página
            });
        }
    }, []); // El array vacío asegura que este efecto se ejecute solo una vez al montar el componente

    return (
        <main>
            <Hero subtitle="Pilates, Biomecánica, Nutrición, Entrenamientos, Osteopatía, Postural" />

            <section className={styles.contenido}>

                <h1>Tarifas</h1>

                <div className={styles.seccion}>
                    <h2>Fisioterapia Deportiva</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>TRATAMIENTO</th>
                                <th>PRECIO</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Fisioterapia Deportiva</td>
                                <td>55€</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className={styles.seccion}>
                    <h2>Ecografía</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>TRATAMIENTO</th>
                                <th>PRECIO</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Ecografía</td>
                                <td>50€</td>
                            </tr>
                            <tr>
                                <td colSpan="2" className={styles.nota}>Realizado por nuestro equipo</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className={styles.seccion}>
                    <h2>Rehabilitación</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>TRATAMIENTO</th>
                                <th>DURACIÓN (minutos)</th>
                                <th>PRECIO</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Rehabilitación</td>
                                <td>30</td>
                                <td>40€</td>
                            </tr>
                            <tr>
                                <td>Rehabilitación</td>
                                <td>60</td>
                                <td>55€</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className={styles.seccion}>
                    <h2>Osteopatía</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>TRATAMIENTO</th>
                                <th>PRECIO</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Osteopatía</td>
                                <td>60€</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className={styles.seccion}>
                    <h2>Pilates</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>SESIONES</th>
                                <th>PRECIO TOTAL</th>
                                <th>PRECIO SESIÓN</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>45€</td>
                                <td>45€</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>80€</td>
                                <td>40€</td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>140€</td>
                                <td>35€</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className={styles.seccion}>
                    <h2>Fisioterapia</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>SESIONES</th>
                                <th>PRECIO TOTAL</th>
                                <th>PRECIO SESIÓN</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>55€</td>
                                <td>55€</td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>144€</td>
                                <td>48€</td>
                            </tr>
                            <tr>
                                <td>6</td>
                                <td>276€</td>
                                <td>46€</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className={styles.seccion}>
                    <h2>Fisioterapia + Ecografía</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>SESIONES</th>
                                <th>PRECIO TOTAL</th>
                                <th>PRECIO SESIÓN</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>70€</td>
                                <td>70€</td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>170€</td>
                                <td>56,60€</td>
                            </tr>
                            <tr>
                                <td>5</td>
                                <td>270€</td>
                                <td>54€</td>
                            </tr>
                            <tr>
                                <td>7</td>
                                <td>350€</td>
                                <td>50€</td>
                            </tr>
                            <tr>
                                <td>10</td>
                                <td>480€</td>
                                <td>48€</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className={styles.seccion}>
                    <h2>Fisioterapia + Presoterapia</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>SESIONES</th>
                                <th>PRECIO TOTAL</th>
                                <th>PRECIO SESIÓN</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>60€</td>
                                <td>60€</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className={styles.seccion}>
                    <h2>Osteopatía</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>SESIONES</th>
                                <th>PRECIO TOTAL</th>
                                <th>PRECIO SESIÓN</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>60€</td>
                                <td>60€</td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>165€</td>
                                <td>55€</td>
                            </tr>
                            <tr>
                                <td>6</td>
                                <td>312€</td>
                                <td>52€</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className={styles.seccion}>
                    <h2>Diatermia</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>SESIONES</th>
                                <th>PRECIO TOTAL</th>
                                <th>PRECIO SESIÓN</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>40€</td>
                                <td>40€</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className={styles.seccion}>
                    <h2>Médico Rehabilitador</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>TRATAMIENTO</th>
                                <th>PRECIO</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Primera visita con ecografía</td>
                                <td>90€</td>
                            </tr>
                            <tr>
                                <td>Segunda visita con ecografía</td>
                                <td>75€</td>
                            </tr>
                            <tr>
                                <td>Infiltración de ácido hialurónico (incluye la visita del doctor)</td>
                                <td>310€</td>
                            </tr>
                            <tr>
                                <td>Factores de crecimiento (PRP) (incluye la visita del doctor)</td>
                                <td>290€</td>
                            </tr>
                            <tr>
                                <td>Infiltración de corticoides y anestésico local (incluye la visita del doctor)</td>
                                <td>190€</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className={styles.seccion}>
                    <h2>Precios para sesiones los sábados y domingos <br /> (domingos citas sólo por teléfono)</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>DÍA</th>
                                <th>PRECIO</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Sábados</td>
                                <td>70€</td>
                            </tr>
                            <tr>
                                <td>Domingos</td>
                                <td>80€</td>
                            </tr>
                        </tbody>
                    </table>
                    <div className={styles.seccionAviso}>
                        <p className={styles.nota}>
                            * Los bonos de 3 y 5 sesiones tendrán una fecha de caducidad de 6 meses y los bonos de 7 y 10 sesiones tendrán 1 año de caducidad.
                        </p>
                        <p className={styles.nota}>
                            La cancelación de las citas que han sido confirmadas por parte del paciente deben notificarse con al menos 6 de horas de antelación, sino es así se cobrarán. Excepto por causa de fuerza mayor.
                        </p>
                        <p className={styles.nota}>
                            No se realizan reembolsos de las sesiones compradas en nuestro centro.
                        </p>
                    </div>
                </div>

            </section>
        </main>
    );
}
